<template>
  <PageHeader></PageHeader>
  <div class="page-wrapper">
    <div class="container">
      <div class="content">
        <!-- Page Title -->
        <h1 class="page-title">Blog</h1>

        <!-- Blog Posts Loop -->
        <div
          v-for="post in posts"
          :key="post.id"
          class="post-item"
        >
          <!-- Image -->
          <a :href="'/blog/' + post.id" class="post-image">
            <img
              :src="post.image"
              :alt="post.imageDescription"
            />
          </a>

          <!-- Content Area -->
          <div class="post-content">
            <!-- Post Info -->
            <h2 class="post-title">{{ post.title }}</h2>
            <p class="post-meta">
              By {{ post.author }} - {{ post.date }}
            </p>
            <!-- Excerpt -->
            <p class="post-excerpt">{{ post.excerpt }}</p>
            <!-- Read More Link -->
            <a :href="'/blog/' + post.id" class="read-more">
              Read More
            </a>
          </div>
        </div>

        <!-- Pagination Controls -->
        <div class="pagination">
          <div>
            <template v-if="page > 0">
              <button class="pagination-btn" @click="newerLink">Newer Posts</button>
            </template>
          </div>
          <div>
            <template v-if="page > 1 || page == 0">
              <button class="pagination-btn" @click="olderLink">Older Posts</button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/PageHeader.vue';

export default {
  name: 'BlogListing',
  components: {
    PageHeader
  },
  data() {
    return {
      posts: [],
      // Hardcoded maximum page (update this value as needed)
      maxPage: 1,
    };
  },
props: {
    // Expecting the router to pass the query param as a prop
    page: {
      type: [Number],
      default: 0
    }
  },    
  computed: {
    // Compute currentPage based on the passed prop
    currentPage() {
      const pageNumber = parseInt(this.page, 10);
      // Return 0 (default listing) if invalid or out of bounds
      if (!pageNumber || pageNumber < 1 || pageNumber > this.maxPage) {
        return 0;
      }
      return pageNumber;
    }
     }, 
  methods: {
    loadPosts() {
      // Build the file path based on the currentPage value.
      let filePath = '/posts/blog_listing.json';
	if (this.currentPage > 0) {
	    
        filePath = `/posts/blog_listing_page_${this.currentPage}.json`;
      }
      fetch(filePath)
        .then(response => response.json())
        .then(data => {
          this.posts = data;
        })
        .catch(err => {
          console.error('Error fetching posts:', err);
          this.posts = [];
        });
    },
olderLink() {
	  // 
	  console.log("WTF")
	  console.log(this.page)
	  //this.$router.push(
    if (this.page == 0) {
	console.log("WTF 2",this.maxPage)
	return this.$router.push(`/blog/page/${this.maxPage}`)//.then(() => {this.$router.go(0);});
	
	}

	  
	  this.$router.push(`/blog/page/${this.page-1}`)//.then(() => {this.$router.go(0);});
	 
    },
      newerLink() {
	  const pageNumber = parseInt(this.page, 10) + 1;
	  if (pageNumber > this.maxPage)
	      return  this.$router.push(`/blog`)
	  
	  console.log("WTF",pageNumber,`/blog/page/${pageNumber}`)
	   this.$router.push(`/blog/page/${pageNumber}`)//.then(() => {this.$router.go(0);});

	  }
      
    
   
  },
 watch: {
    // When the "page" prop changes, reload the posts.
    page() {
      this.loadPosts();
    }
  },
  mounted() {
    this.loadPosts();
  }
};
</script>

<style scoped>
/* Add any additional component-specific styles here */

.page-wrapper {
  min-height: 100vh;
  background-color: white;
  padding: 2rem 1rem;
}

.container {
  max-width: 64rem;
  margin: 0 auto;
  position: relative;
}

.content {
  background-color: white;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 2.25rem;
  font-weight: 600;
  color: #c2410c;
  margin-bottom: 2rem;
}

.post-item {
  display: flex;
  flex-wrap: wrap;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border-radius: 0.5rem;
  background-color: #f9fafb;
}

.post-image {
  width: 100%;
  max-width: 50%;
}

.post-image img {
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: top;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}

.post-content {
  flex: 1;
  padding: 0 1rem;
}

.post-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #1f2937;
}

.post-meta {
  font-size: 0.875rem;
  color: #4b5563;
}

.post-excerpt {
  color: #374151;
  margin-top: 0.5rem;
}

.read-more {
  color: #3b82f6;
  text-decoration: none;
}

.read-more:hover {
  text-decoration: underline;
}

.pagination {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}

.pagination-btn {
  background-color: #3b82f6;
  color: white;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.pagination-btn:hover {
  background-color: #2563eb;
}

.pagination-btn:active {
  background-color: #1e40af;
}
</style>
